<template>
  <BNavbar class="text-white" variant="primary" fixed="top" data-bs-theme="dark">
    <slot></slot>
    <BNavbarNav class="ms-auto text-white">
      <BNavItem to="/"><Icon icon="bi:house-door-fill" style="font-size: 20px"/></BNavItem>
      <template v-if="user">
        <BDropdown variant="link" no-caret end>
          <template #button-content>
            <img :src="user.avatarUrl ?? undefined" class="avatar" alt="" />
          </template>
          <BDropdownItem @click="logout">Sign out</BDropdownItem>
        </BDropdown>
      </template>
      <template v-else>
        <BNavItem id="loginButton" link-class="nav-icon" @click="showLogin = true">
          <Icon icon="bi:person" style="font-size: 20px" />
        </BNavItem>
      </template>
    </BNavbarNav>
  </BNavbar>
  <LoginDialog v-model="showLogin" />
</template>

<script setup lang="ts">
import { ref } from 'vue'
import { BNavbar, BNavbarNav, BNavItem, BDropdown, BDropdownItem } from 'bootstrap-vue-next'
import { Icon } from '@iconify/vue'
import { user, logout } from '@/stores/auth'
import LoginDialog from '@/components/LoginDialog.vue'

const showLogin = ref(false)
</script>

<style lang="scss">
@import '../main.scss';

.navbar {
  small {
    font-size: 11px;
    line-height: 1;
    margin-left: 2em;
  }

  .navbar-brand {
    text-overflow: ellipsis;
    overflow: hidden;
    line-height: 1.2;
  }

  .navbar-nav {
    align-items: center;

    .nav-link {
      display: flex;
      align-items: center;
      color: rgba(255, 255, 255, 0.75);

      &:hover, &.active {
        color: #fff;
      }

      &.btn-light {
        color: #333;
      }
    }
  }
}

.avatar {
  width: 28px;
  height: 28px;
  border-radius: 50%;
  object-fit: cover;
}

.offcanvas {
  .nav {
    li.form-inline {
      display: block;
    }

    .form-inline.block {
      display: block;

      .form-group {
        display: block;
        margin-bottom: 1rem;
      }

      .btn-group-vertical {
        width: 100%;

        label {
          display: block;
          text-align: left;
        }
      }
    }
  }
}
</style>
